import angular from 'angular';

import RwButtonComponent from './rw-button-component';

export default angular.module('rw-button', []).component('rwButton', new RwButtonComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-button/rw-button-module.js